import { useMutation, useQueryClient } from "@tanstack/react-query";
import adminApi from "../../api/adminApi";

export const useCreateCourse = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: {
            title: string,
            description: string,
            duration: number,
            price : number,
            prerequisiteCourseIds: Array<number>
        }) => adminApi.createCourse(data),

        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["courses"],
            });
        },
    });
};
